<template>
  <b-nav class="main-nav">
    <b-nav-item class="logo" @click="$router.push('dashboard')">
      <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout" v-if="dashboardActive"
                               active
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item class="logout" v-else
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item-dropdown class="logout"
                         id="nav7_ddown"
                         text="Account"
                         extra-toggle-classes="nav-link-custom"
                         extra-menu-classes="nav-item-color"
                         right>
      <b-dropdown-item v-if="role === 'admin'"
                       class="logout2"
                       @click="showUsers()">Users
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'"
                       class="logout2"
                       @click="getLoginHistory()">Login History
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'"
                       class="logout2"
                       @click="getUsageHistory()">License History
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin' || role === 'subadmin' || showPeopleCounterOverhead"
                       class="logout2"
                       @click="getRollOut()">Rollout
      </b-dropdown-item>
      <b-dropdown-item v-if="role === 'admin'"
                       class="logout2"
                       @click="getHubspotDeal()">Hubspot Deal
      </b-dropdown-item>
      <b-dropdown-item class="logout2" @click="profile()">Update Profile</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="showPrivacy()">Privacy Policy</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="showLegal()">Legal</b-dropdown-item>
      <b-dropdown-item class="logout2" @click="logout()">Logout</b-dropdown-item>
    </b-nav-item-dropdown>

    <b-modal v-model="confirmModal"
             title="Confirm Amount"
             ok-variant="secondary"
             ok-title="Yes"
             cancel-title="No"
             @ok="handleOk"
             @cancel="handleCancel">
      {{confirmAmount}}
    </b-modal>
  </b-nav>
</template>

<script>
import Session from '@/Session';
import API from '@/api';

export default {
  name: 'FacitHeader',
  data() {
    const token = Session.getAccessToken();
    const credits = token.user.credits;
    const purchased = token.user.purchased;
    const userRole = token.user.role;
    return {
      credit: credits,
      amount: null,
      purchase: purchased,
      selectedOther: false,
      inputValue: null,
      creditModal: false,
      options: null,
      activeLink: null,
      country: null,
      packageNo: 1,
      confirmModal: false,
      confirmAmount: null,
      dashboardActive: true,
      licenceKey: null,
      licenceModalShow: false,
      packageName: null,
      packageModalShow: false,
      lightUpgrade: true,
      lightUpgrade1: true,
      lightUpgrade2: true,
      lightUpgrade3: true,
      lightUpgrade4: true,
      role: userRole,
      showPeopleCounterOverhead: false,
    };
  },
  created() {
    let emailAddress = Session.getAccessToken().user.email
    emailAddress = emailAddress.toLowerCase()
    if (emailAddress === 'support@vi2vi-retail-solution.com') {
      this.showPeopleCounterOverhead = true
    }
    const pageName = this.$route.name;
    if (pageName === 'dashboard') {
      this.dashboardActive = true;
    } else {
      this.dashboardActive = false;
    }
  },
  methods: {
    async paymentCredits() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          let vatTax = 0;
          let devices = 1;
          const token = Session.getAccessToken();
          const userId = token.user.id;
          const country = token.user.country;
          const customer = token.user.customerId;
          const plan = this.amount.planId;
          const packageNo = this.amount.id;
          const address = token.user.address;
          this.creditModal = false;
          if (address) {
            if (country === 'United Kingdom') {
              vatTax = 20;
            }
            if (packageNo === 3) {
              devices = 5;
            } else if (packageNo === 4) {
              devices = 10;
            }
            await this.$checkout.open({
              name: 'Facit Data Systems',
              currency: 'GBP',
              token: async (newToken) => {
                try {
                  this.amount = null;
                  const tokenId = newToken.id;
                  const charged = await API.post(`Accounts/${userId}/charge`, {
                    token: tokenId,
                    customerId: customer,
                    vat: vatTax,
                    planId: plan,
                    packageId: packageNo,
                    totalDevices: devices,
                  });
                  Session.updateUser(charged);
                  this.credit = charged.credits;
                  this.$eventHub.$emit('credit-updated');
                  this.purchase = true;
                } catch (error) {
                  this.$eventHub.$emit('credit-updated');
                  this.$notify({
                    group: 'sitewide',
                    title: 'Error!',
                    type: 'error',
                    text: 'Error occured please try again!',
                  });
                }
              },
            });
          } else {
            this.$notify({
              group: 'sitewide',
              title: 'Error!',
              type: 'error',
              text: 'Kindly update profile!',
            });
            this.$router.push('/profile');
          }
        }
      } catch (error) {
        this.$eventHub.$emit('credit-updated');
        this.creditModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error occured please try again!',
        });
      }
    },
    async getPackageList() {
      try {
        const packageList = await API.get('PackageLists');
        this.options = packageList;
      } catch (error) {
        console.error(error);
      }
    },
    async paymentPurchase() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          this.confirmModal = true;
          this.confirmAmount = `Please confirm amount: £${this.inputValue}.00`;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getAccount() {
      try {
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const AccountDetail = await API.get(`Accounts/${userId}/`);
        Session.updateUser(AccountDetail);
      } catch (error) {
        console.error(error);
      }
    },
    async handleOk() {
      try {
        let vatAmount = 0;
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const country = token.user.country;
        const customer = token.user.customerId;
        const amount = parseInt(this.inputValue, 10);
        const address = token.user.address;

        if (address) {
          if (country === 'United Kingdom') {
            vatAmount = amount * 0.2;
          }
          const totalAmount = (amount + vatAmount) * 100;
          await this.$checkout.open({
            name: 'Facit Data Systems',
            currency: 'GBP',
            amount: totalAmount,
            token: async (newToken) => {
              try {
                this.amount = null;
                const tokenId = newToken.id;
                const charged = await API.post(`Accounts/${userId}/purchase`, {
                  credits: totalAmount,
                  token: tokenId,
                  vat: vatAmount,
                  customerId: customer,
                });
                Session.updateUser(charged);
                this.$eventHub.$emit('credit-updated');
                this.creditModal = false;
                this.credit = charged.credits;
              } catch (error) {
                this.$eventHub.$emit('credit-updated');
                this.creditModal = false;
                this.$notify({
                  group: 'sitewide',
                  title: 'Error!',
                  type: 'error',
                  text: 'Error occured please try again!',
                });
              }
            },
          });
        } else {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Kindly update profile!',
          });
          this.$router.push('/profile');
        }
      } catch (error) {
        this.$eventHub.$emit('credit-updated');
        this.creditModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error occured please try again!',
        });
      }
    },
    handleCancel() {
      this.creditModal = true;
    },
    logout() {
      Session.removeAccessToken();
      this.$router.push('../login');
    },
    dashboard() {
      this.$router.push('/');
    },
    showLegal() {
      this.$router.push('../legal');
    },
    showPrivacy() {
      this.$router.push('../privacy');
    },
    profile() {
      this.$router.push('profile');
    },
    showUsers() {
      this.$router.push('/admin/users');
    },
    async getLoginHistory() {
      this.$router.push(`/admin/loginHistory`);
    },
    async getUsageHistory() {
      this.$router.push(`/admin/usageHistory`);
    },
    async getRollOut() {
      this.$router.push(`/admin/rollOut`);
    },
    async getHubspotDeal() {
      try {
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const hubspotDeal = await API.post(`Accounts/${userId}/hubspotDeal`, {
          record: 'data'
        });
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error occured please try again!',
        });
      }
    },
    support() {
      this.$router.push('support');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #656580 !important;
}

.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}

.logo {
  margin-top: 20px;
  width: 80%;
  margin-left: 30px;
}

.logout {
  margin-top: 28px;
}
.logout2 {
  margin-top: 10px;
}
.active {
  color: #ff8f00 !important;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}

.menu-item button {
  color: #656580 !important;
}
.nav-link-custom {
    background: white;
    border: #fe5623;
    color: #656580 !important;
}

.btn-link {
  color: red !important;
}


li > a > span{
  color: #656580 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue